import { FeatherClipboardCheck } from "@subframe/core";

import { EntityIcon } from "@/components/ui/entity-icon";
import { asCategoryType, categoryColor } from "@/lib/category-display";

export { CategoryPill } from "@/components/ui/category-pill";

/**
 * The checklist row's entity glyph, tinted by its primary category. Falls back
 * to a neutral clipboard when the category slug isn't part of the fixed icon
 * matrix (e.g. an admin-created category).
 */
export function ChecklistEntityIcon({
  slug,
  color,
  size = 32,
}: {
  slug?: string;
  color?: string;
  size?: number;
}) {
  const category = asCategoryType(slug);
  if (category) {
    return <EntityIcon entity="checklist" category={category} size={size} />;
  }
  const tint = categoryColor(slug, color);
  return (
    <span
      className="inline-flex items-center justify-center rounded-md"
      style={{
        width: size,
        height: size,
        backgroundColor: tint ? `${tint}1A` : "#F1F1F1",
        color: tint ?? "#6B7280",
      }}
    >
      <FeatherClipboardCheck
        style={{ width: size * 0.5, height: size * 0.5 }}
      />
    </span>
  );
}
